import { Api } from 'src/core/decorators/dto/api.decorator';
import { DtoHasApi } from '../shared/dto-has-api.model';

@Api('api/app/phrase-suggestion')
export class PhraseSuggestionRequestDto extends DtoHasApi {
  languageCode: string;
  phrases: string[];
  count: number;
}
